import React from "react";
import { LegacyPortal } from "./components/LegacyPortal.jsx";
import { LoginPage } from "./pages/LoginPage.jsx";
import { ResetPasswordPage } from "./pages/ResetPasswordPage.jsx";
import { CompleteRegistrationPage } from "./pages/CompleteRegistrationPage.jsx";

function NotFound() {
  return (
    <main className="react-status-page">
      <section className="react-status-card">
        <h1>Page not found</h1>
        <p>The requested STEMEIT page is not available in this frontend.</p>
        <a className="auth-primary-btn react-link-button" href="/Account/Login">Return to login</a>
      </section>
    </main>
  );
}

export default function App() {
  const pathname = window.location.pathname.toLowerCase().replace(/\/+$/, "") || "/";

  if (pathname.startsWith("/admin")) return <LegacyPortal role="admin" />;
  if (pathname.startsWith("/client")) return <LegacyPortal role="client" />;
  if (pathname.startsWith("/supplier")) return <LegacyPortal role="supplier" />;

  if (pathname === "/account/resetpassword") return <ResetPasswordPage />;
  if (pathname === "/account/completeregistration") return <CompleteRegistrationPage />;
  if (pathname === "/" || pathname === "/account" || pathname === "/account/login") {
    return <LoginPage />;
  }

  return <NotFound />;
}
